import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component';
import {UmpireImage} from '../umpire-image';

export interface UmpireComponentHeroThematic
  extends UmpireComponent<UmpireComponentTypeEnum.HERO_THEMATIC> {
  title: string;
  description: string;
  external_url: string;
  has_gradient: boolean;
  button_label: string;
  button_text: string;
  alignment: 'left' | 'right';
  image: UmpireImage;
  content_visibility: 'all_users' | 'signed_in_users' | 'unsigned_users';
}
